'use client'
import { Table, TableRow, TableHeader, TableCell, ColorButton, ConfirmMessage } from "@/components/ui";
import { defaultQuestion, QuestionIdResponseType } from "@/types";
import { getQuestionId, deleteQuestion } from "@/app/api";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";


export function DeleteQuestion({ id }: { id: string }) {
    const router = useRouter();
    const [loading, setLoading] = useState<boolean>(false)
    const [openMessage, setOpenMessage] = useState<boolean>(false)
    const [questionData, setQuestionData] = useState<QuestionIdResponseType>()

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await getQuestionId(id)
                if (response !== undefined) {
                    setQuestionData(response)
                }
            } catch (e) {
                console.log('Não foi possível buscar o usuário: ', e)
            }
        }

        fetchUser()
    }, [id]);

    const question = questionData || defaultQuestion

    const handleDeleteQuestion = async () => {
        setLoading(true)
        try {
            const res = await deleteQuestion(id)
            if (res) {
                router.back()
            }
        } catch (err) {
            console.log("Erro ao excluir pergunta: ", err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="p-8">
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Sequência</TableHeader>
                            <TableHeader>Conteúdo</TableHeader>
                            <TableHeader>Autor</TableHeader>
                            <TableHeader>Email do autor</TableHeader>
                            <TableHeader>Status</TableHeader>
                            <TableHeader>Data do envio</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow>
                            <TableCell>{question.sequence}</TableCell>
                            <TableCell>{question.content}</TableCell>
                            <TableCell>
                                {question.user?.name ? 'Usuário' : 'Visitante'} - {question.user?.name || question.visitor?.name}
                            </TableCell>
                            <TableCell>
                                {question.user?.email || question.visitor?.email || 'Não informado'}
                            </TableCell>
                            <TableCell>
                                {question.status === 'PENDING' ? 'Pendente'
                                    : question.status === 'APPROVED' ? "Aprovada"
                                        : question.status === 'REJECTED' ? 'Rejeitada'
                                            : question.status === 'FLAGGED' ? 'Sinalizada'
                                                : 'Pendente'
                                }
                            </TableCell>
                            <TableCell>{new Date(question.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableHeader>Resposta</TableHeader>
                            <TableCell colSpan={4}>{question.answer}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        <TableRow>
                            <TableHeader>Sequência</TableHeader>
                            <TableCell>{question.sequence}</TableCell>
                            <TableHeader>Conteúdo</TableHeader>
                            <TableCell>{question.content}</TableCell>
                            <TableHeader>Autor</TableHeader>
                            <TableCell>
                                {question.user?.name ? 'Usuário' : 'Visitante'} - {question.user?.name || question.visitor?.name}
                            </TableCell>
                            <TableHeader>Email do autor</TableHeader>
                            <TableCell>
                                {question.user?.email || question.visitor?.email || 'Não informado'}
                            </TableCell>
                            <TableHeader>Status</TableHeader>
                            <TableCell>
                                {question.status === 'PENDING' ? 'Pendente'
                                    : question.status === 'APPROVED' ? "Aprovada"
                                        : question.status === 'REJECTED' ? 'Rejeitada'
                                            : question.status === 'FLAGGED' ? 'Sinalizada'
                                                : 'Pendente'
                                }
                            </TableCell>
                            <TableHeader>Data do envio</TableHeader>
                            <TableCell>{new Date(question.createdAt).toLocaleDateString()}</TableCell>
                            <TableHeader>Resposta</TableHeader>
                            <TableCell>{question.answer}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <div className="flex flex-col gap-3 p-4  items-center justify-center">
                <ColorButton disabled={loading} onClick={() => setOpenMessage(true)}>
                    {loading ? 'Excluindo...' : 'Excluir'}
                </ColorButton>
            </div>

            <ConfirmMessage
                isOpen={openMessage}
                title="Confirmar exclusão"
                message="Tem certeza que deseja excluir essa pergunta? Essa ação não poderá ser desfeita."
                onConfirm={handleDeleteQuestion}
                onCancel={() => setOpenMessage(false)}
            />

        </div>
    )
}